import type { AccountStatusSnapshot } from '@src/models/interfaces/accountStatus.interface';
import { AccountStatusMapper } from '@src/models/mappers/AccountStatusMapper';
import AccountStatusRepository from '@src/repositories/AccountStatusRepository';

class AccountStatusService {
  private readonly repository = new AccountStatusRepository();

  /** Live account status of an organization; a missing document is reported as `trialing`. */
  subscribe(
    organizationId: string,
    onChange: (snapshot: AccountStatusSnapshot) => void,
    onError: (error: Error) => void,
  ): () => void {
    return this.repository.subscribe(
      organizationId,
      dto => onChange(AccountStatusMapper.fromDTO(dto)),
      onError,
    );
  }
}

export default AccountStatusService;
